import { defineMessages } from 'react-intl';

// eslint-disable-next-line import/no-default-export
export default defineMessages({
    title: {
        id: '_.your_company.payment_details.title',
        defaultMessage: 'Payment Details'
    },
    subtitle: {
        id: '_.your_company.payment_details.subtitle',
        defaultMessage:
            'Link debit cards and add bank details so that we know where to send funds and can take repayments'
    },
    addBankAccount: {
        id: '_.your_company.payment_card_label.add_bank_account',
        defaultMessage: 'Business bank details'
    },
    addDebitCard: {
        id: '_.your_company.payment_card_label.add_debit_card',
        defaultMessage: 'Add debit card'
    },
    addBankNumberAndDebitCard: {
        id: '_.your_company.payment_card_label.add_bank_account_or_debit_card',
        defaultMessage: 'Add bank account or debit card'
    }
});
